<template>
  <v-row class="ma-1">
    <v-col md="12" cols="12">
      <v-toolbar class="mb-2" color="primary" dark flat>
        <v-toolbar-title>{{ getDescription(typ) }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <v-btn @click="expandFilter = !expandFilter" text>{{
            expandFilter ? "Schovať filter" : "Zobraziť filter"
          }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-col>
    <v-col md="12" cols="12">
      <meranie-table
        :typ="typ"
        :editable="true"
        :showFilter="true"
        :expandFilter="expandFilter"
      />
    </v-col>
  </v-row>
</template>
<script>
import MeranieTable from "../components/MeranieTable.vue"
import * as Enums from "../plugins/enums.js"

export default {
  components: {
    MeranieTable
  },
  data: function() {
    return {
      expandFilter: false,
      users: []
    }
  },
  computed: {
    typ: function() {
      return this.$route.params.typ
    }
  },

  methods: {
    getDescription: function(mer) {
      return Enums.getDescription(mer)
    }
  }
}
</script>
